export default __webpack_public_path__ + "static/media/course_11.0807bd9d.png";